import React from 'react';

const styles = {
  notScheduled: {
    background: '#808080'
  }
}
const NotScheduled = ({index}) => (
  <td
  className="Not-scheduled"
  style={styles.notScheduled}>
</td>

);


export default NotScheduled;



// WEBPACK FOOTER //
// ./src/screens/schedules/slots/NotScheduled.js